import { useLocation } from 'react-router'
import { useEffect } from 'react'
import { useAuth } from '@praxis/component-auth'
import { useAnalytics } from '@praxis/analytics/client'
import { logEvent } from '@praxis/component-logging'
import { Card, Grid, Layout } from '@enterprise-ui/canvas-ui-react'
import { SectionHeader } from '../globalComponents/SectionHeader'
import apiConfig from '../globalConfig/apiConfig'
import {
  CUSTOM_ANALYTICS_TYPES,
  CUSTOM_ANALYTICS_EVENT_NAMES,
} from '../globalConfig/constants'

export const UnfoundRoute = () => {
  const location = useLocation()
  const auth = useAuth()
  const userLanId = auth?.session?.userInfo?.lanId
  const { sendEvent } = useAnalytics()

  useEffect(() => {
    logEvent(
      {
        message:
          auth?.session?.userInfo?.fullName +
          ' (' +
          auth?.session?.userInfo?.lanId +
          ') tried to access an unknown route: ' +
          location.pathname,
      },
      apiConfig.logging,
    )

    sendEvent({
      event: {
        type: CUSTOM_ANALYTICS_TYPES.ROUTE_NOT_FOUND,
        id: CUSTOM_ANALYTICS_EVENT_NAMES.ROUTE_NOT_FOUND,
        value: location.pathname,
      },
      client: {
        employee_login_id: userLanId,
      },
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    auth?.session?.userInfo?.fullName,
    auth?.session?.userInfo?.lanId,
    location,
    userLanId,
  ])

  return (
    <>
      <SectionHeader
        className="hesp-sectionHeader-layout"
        pageHeading="Oops!"
      />
      <Layout.Body
        className="hesp-generic-layout"
        data-testid="layoutWithUnfoundRouteContent"
        includeRail
      >
        <Card className="hc-pa-normal">
          <Grid.Container>
            <Grid.Item className="hesp-general-fullwidth">
              <p>Oops! We couldn't find the page you are looking for.</p>
            </Grid.Item>
          </Grid.Container>
        </Card>
      </Layout.Body>
    </>
  )
}
